
import Vue from 'vue'
import ToTop from '@/components/toTop/index.vue'
export default Vue.extend({
	components: {
		ToTop
	}
})
